export default __webpack_public_path__ + "static/media/Sello-Coopeuch.d6421d38.svg";